import React from "react";
import { pageSizeConfigs } from 'Main/Utils'
import LogUserFilter from 'views/components/Input/LogUserFilter'

export function ApiTrafficLogsToolbar({
  filterEndpoint,
  filterStatus,
  pageSize,
  endpointOptions,
  filterUserId,
  showUserFilter,
  users,
  loadingUsers,
  onUserChange,
  onEndpointChange,
  onStatusChange,
  onPageSizeChange,
  dateFrom,
  dateTo,
  onChange,
  onClear,
}) {
  return (
    <div className="row g-2 mb-3">
      {showUserFilter && (
        <LogUserFilter
          value={filterUserId}
          users={users}
          loading={loadingUsers}
          onChange={onUserChange}
        />
      )}
      <div className="col-12 col-md-3">
        <label className="form-label small text-muted mb-1">Endpoint</label>
        <select className="form-select" value={filterEndpoint} onChange={onEndpointChange}>
          <option value="%">All Endpoints</option>
          {endpointOptions.map((ep) => (
            <option key={ep} value={ep}>
              {ep}
            </option>
          ))}
        </select>
      </div>

      <div className="col-6 col-md-2">
        <label className="form-label small text-muted mb-1">From</label>
        <input
          type="date"
          className="form-control"
          value={dateFrom}
          onChange={(e) => onChange({ from: e.target.value, to: dateTo })}
        />
      </div>

      <div className="col-6 col-md-2">
        <label className="form-label small text-muted mb-1">To</label>
        <input
          type="date"
          className="form-control"
          value={dateTo}
          onChange={(e) => onChange({ from: dateFrom, to: e.target.value })}
        />
      </div>

      <div className="col-12 col-md-2">
        <label className="form-label small text-muted mb-1">Status</label>
        <select className="form-select" value={filterStatus} onChange={onStatusChange}>
          <option value="%">All Status</option>
          <option value="SUCCESS">SUCCESS</option>
          <option value="FAIL">FAIL</option>
        </select>
      </div>

      <div className="col-12 col-md-1">
        <label className="form-label small text-muted mb-1">Size</label>
        <select className="form-select" value={pageSize} onChange={onPageSizeChange}>
          {pageSizeConfigs.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>

      <div className="col-12 col-md-2 d-flex align-items-end gap-2">
        <button type="button" className="btn btn-light text-black flex-fill" onClick={onClear}>
          <i className="fa-solid fa-rotate-left" /> Reset
        </button>
      </div>
    </div>
  );
}

export default ApiTrafficLogsToolbar;
